import { cornType } from '@eigtech/shared-corn';
import { z } from 'zod';
import { ContactRoleConsumerSchema, contactsServiceCorn } from './contacts.js';
/**
 * WARNING!! Do not use outside of schemas!
 */
const globalBookCorn = (resourceId) => cornType('contacts', 'book', resourceId);
export const BookCornSchema = contactsServiceCorn('book');
export const BookTypeEnumSchema = z.enum(['claim', 'global', 'other', 'job']);
export const BookMetadataSchema = z
    .object({
    name: z.string(),
    type: BookTypeEnumSchema,
})
    .passthrough();
export const BookSchema = z.object({
    bookId: BookCornSchema,
    metadata: BookMetadataSchema,
});
export const GlobalBookResourceIdSchema = z.enum([
    'carrier',
    'csr',
    'deskAdjuster',
    'fieldAdjuster',
    'reviewer',
    'fieldTechnician',
    'subcontractor',
    'projectManager',
]);
/**
 * WARNING!! The resource ID is NOT NECESSARILY an enum, any old string works!
 * Do not rely on this for enum enforcement!
 */
export const GlobalBookCornSchema = globalBookCorn();
export const GlobalRoleToBookMapSchema = z
    .object({ role: ContactRoleConsumerSchema, book: GlobalBookCornSchema })
    .array();
